import { mapState } from 'vuex';

/* eslint-disable prefer-destructuring */
export default {
  created() {
    if (!this.tokenConfiguration)
      this.$store.dispatch('juno/loadConfigurations');
    else this.checkIntegrationRoute();
  },
  methods: {
    checkIntegrationRoute() {
      if (this.$router.currentRoute.name !== 'juno-token')
        this.$router.replace({ name: 'juno-token' });
    },
    changeRoute(routeName, params = {}) {
      this.$router.push({ name: routeName, params });
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      tokenConfiguration: (state) => state.juno.tokenConfiguration,
      tokenConfigurationIsActive: (state) =>
        state.juno.tokenConfigurationIsActive,
    }),
  },
  watch: {
    tokenConfiguration() {
      this.checkIntegrationRoute();
    },
  },
};
